module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Rose.790ac93c.jpg";